const apiUrls = require('../../constants/apiUrls');

const packageDetails = {
    key: 'packageDetails',
    method: 'GET',
    getApiUrl: (request) => {
        return `${apiUrls.PACKAGE_DETAIL_URL}?billingSystem=${request.billingSystem}&accountNumber=${request.accountNumber}`;
    },
    dependencies: [
        {
            key: 'orderDetails',
            requestProps: [
                {
                    path: [
                        'details', 'accountNumber'
                    ],
                    propName: 'accountNumber'
                }
            ]
        }, {
            key: 'schedulingSystemDetails',
            requestProps: [
                {
                    path: [
                        'details', 'billingSystem'
                    ],
                    propName: 'billingSystem'
                }
            ]
        }
    ]
};

export default packageDetails;



// WEBPACK FOOTER //
// ./src/store/order-details-config/packageDetails.js